export enum EventTypeEnum {
    PageInteraction = "pageInteraction",
    QuestComplete = "questComplete",
    Loading = "loading",
    ErrorLoad = "errorLoad",
    ErrorEvent = "errorEvent",
}

export enum AdobeEventTypeEnum {
    PageView = "pageView",
    FormStart = "formStart",
    FormComplete = "formComplete",
    InteractionClick = "interactionClick",
    FormFieldInteraction = "formFieldInteraction",
    FormFieldError = "formFieldError",
    PageViewError = "pageViewError",
}

export interface AdobeProductsModel {
    quote: {
        quoteID?: string | number;
        quotePolicyReference?: string | number;
    };
    cover: {
        coverAmount?: number;
        coverLength?: number;
        coverType: string;
    };
    premium: {
        premiumAnnual?: number;
        premiumMonthly?: number;
        premiumFrequency?: string;
    };
}

export interface AdobeCustomerModel {
    age: number | undefined;
    dateOfBirth: string | null;
    gender: string | undefined;
    emailAddress: string;
    forename: string;
    ids: {
        idol: number | undefined;
    };
    mobilePhoneNumber: string | undefined;
    outcode: string;
    postcode: string;
    smokerStatus: string | undefined;
    surname: string;
    type: string;
}

export interface AdobePageModel {
    appName: string;
    businessArea: string;
    environment: string;
    journey: {
        name: string;
        optimiseSSKey: string;
        route: string;
        syndication: string;
        agencyNo: string;
        campaignCode: string;
        channel: string;
    };
    pageName: string;
    pageTitle: string;
    pageType: string;
    responsiveState: string;
    url: string;
}

export interface AdobeOrderModel {
    paymentMethod: string;
    paymentRegularity: string;
}

export interface AdobePageViewEventModel {
    event: AdobeEventTypeEnum;
    pageViews: {
        value: number;
    };
    customer: AdobeCustomerModel;
    page: AdobePageModel;
    products: AdobeProductsModel[];
}

export interface AdobeDataLayerFormStartEventModel {
    event: AdobeEventTypeEnum;
    formStarts: {
        value: number;
    };
    form: {
        formName: string;
    };
}

export interface AdobeDataLayerFormCompleteEventModel {
    event: AdobeEventTypeEnum;
    formCompletes: {
        value: number;
    };
    form: {
        formName: string;
    };
    customer: AdobeCustomerModel;
}

export interface AdobeInteractionClickEventModel {
    event: AdobeEventTypeEnum;
    interactionClicks: {
        value: number;
    };
    interaction: {
        interactionName: string;
        interactionType: string;
    };
}

export interface AdobeFormFieldInteractionEventModel {
    event: AdobeEventTypeEnum;
    formFieldInteractions: {
        value: number;
    };
    form: {
        formName: string;
        formField: string;
    };
}

export interface AdobeFormFieldErrorEventModel {
    event: AdobeEventTypeEnum;
    fieldErrors: {
        value: number;
    };
    form: {
        formName: string;
        formField: string;
        formErrorMessage: string;
        formErrorType: string;
    };
}

export interface AdobePageErrorEventModel {
    event: AdobeEventTypeEnum;
    pageViews: {
        value: number;
    };
    page: {
        errorCode: number;
        errorMessage: string;
        errorType: string;
    };
}

export interface AdobeFormStartEventModel {
    event: AdobeEventTypeEnum;
    formStarts: {
        value: number;
    };
    form: {
        formName: string;
    };
}

export interface AdobeFormCompleteEventModel {
    event: AdobeEventTypeEnum;
    formCompletes: {
        value: number;
    };
    form: {
        formName: string;
    };
    customer: AdobeCustomerModel;
    order: AdobeOrderModel;
    products: AdobeProductsModel[];
}

export interface DataLayerStoreModel {
    timestamp: string;
    pageNumber: number;
    pageError: {
        errorType: string;
        errorCode: number;
        errorMessage: string;
    } | null;
    adobeDataLayerEvents: (
        | AdobePageViewEventModel
        | AdobeFormFieldInteractionEventModel
        | AdobeInteractionClickEventModel
        | AdobeFormFieldErrorEventModel
        | AdobePageErrorEventModel
        | AdobeFormStartEventModel
        | AdobeFormCompleteEventModel
    )[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [x: string]: any;
}

export interface DataLayerPageModel {
    URL: string;
    appName: string;
    country: string;
    currency: string;
    hostName: string;
    language: string;
    pageName: string;
    pageType: string;
    path: string;
    phoneNumber: string;
    previousPagePath: string;
    resolution: string;
    sessionCamID: string;
    siteSection: string;
    timestamp: string;
    pageVariant?: string;
    interaction?: string;
    environment?: string;
    orientation?: string;
    responsiveState?: string;
    resState?: string;
}

export enum YesNoEnum {
    Yes = "Y",
    No = "N",
}
export interface DataLayerFormModel {
    loadingModalDisplayed: YesNoEnum;
    questionComplete?: boolean;
}
export interface OceanDataModel {
    cr_addurn?: string;
    cr_indurn?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    match_attrs?: any;
    postcode?: string;
    segment_info?: {
        Key?: number;
        Segment?: number;
        SubSegment?: string;
    };
    uid?: string;
}

export interface DataLayerCustomerModel {
    marketing: {
        email: YesNoEnum;
        online: YesNoEnum;
        post: YesNoEnum;
        sms: YesNoEnum;
        telephone: YesNoEnum;
        contactUs: boolean;
    };
    NCEmail: boolean;
    address: {
        addressline1: string;
        city: string;
        postcode: string;
    };
    customerNumber?: number;
    age?: number;
    email?: string;
    firstname?: string;
    gender?: string;
    lastName?: string;
    fbo?: YesNoEnum;
    smoker?: string;
    purchaseReason: string;
    ocean: OceanDataModel;
    dayphone?: string;
}

export interface DataLayerQuoteModel {
    premiumFrequency: string;
    start: boolean;
    coverType?: string;
    Id?: string;
    policyRef?: string;
    annualPremium?: string;
    cover?: string;
    monthlyPremium?: string;
}

export interface DataLayerProductModel {
    coverType: string;
    annualPremium?: string;
    cover?: string;
    monthlyPremium?: string;
}

export interface DataLayerJourneyModel {
    agencyNo: number;
    campaignCode: string;
    channel: string;
    name: string;
    route: string;
    syndication: string;
    sskey: string;
}

export interface DataLayerErrorModel {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorMessage: any[] | string;
    errorType: string;
    errorCode?: number;
}

export interface DataLayerFinalModel {
    journey: DataLayerJourneyModel;
    page: DataLayerPageModel;
    customer?: DataLayerCustomerModel;
    quote?: DataLayerQuoteModel;
    products?: DataLayerProductModel;
    form?: DataLayerFormModel;
    error?: DataLayerErrorModel;
    productProminence: boolean;
    confirmation?: {
        paymentType: string;
    };
}
